import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 bg-white" data-id="element-97">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-900 rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-99">
          {/* Background decoration */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-100">
            <div className="absolute top-0 right-0 w-64 h-64 bg-teal-500 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-101"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-500 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-102"></div>
          </div>

          <div className="relative z-10" data-id="element-103">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4" data-id="element-104">
              Get The NDIS Autism Plan Builder
            </h2>
            <p className="text-gray-300 mb-8 text-lg" data-id="element-105">
              One-time payment. Lifetime access. Future updates included.
            </p>

            <div className="flex items-baseline justify-center mb-8" data-id="element-106">
              <span className="text-xl text-gray-400 line-through mr-3" data-id="element-107">
                $19.99
              </span>
              <span className="text-5xl font-bold text-white" data-id="element-108">$9.99</span>
              <span className="text-gray-400 ml-2" data-id="element-109">AUD</span>
              <span className="ml-3 bg-teal-500 text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-110">
                -50%
              </span>
            </div>

            <Button size="lg" className="w-full md:w-auto min-w-[200px] mb-6 bg-teal-500 hover:bg-teal-400 text-white border-none" data-id="element-111">
              Download Now
            </Button>

            <div className="flex items-center justify-center text-sm text-gray-400" data-id="element-112">
              <ShieldCheck className="h-4 w-4 mr-2" data-id="element-113" />
              <span data-id="element-114">Secure payment via Stripe</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}